import type { Persona } from "./persona"

export const CHART_MODE = {
  line: "LINE",
  candlesticks: "CANDLESTICKS",
} as const

export const CHART_MODE_COOKIE_NAME = "currency-chart-mode-preference"

export const getDefaultChartMode = (persona: Persona) => {
  return persona === "collector" ? CHART_MODE.line : CHART_MODE.candlesticks
}
